import React from 'react';

interface AccountIconProps {
  className?: string;
}

const AccountIcon: React.FC<AccountIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1" fill="none"/>
    <circle cx="8" cy="6" r="2" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M4 12c0-2.5 1.8-4 4-4s4 1.5 4 4" stroke="currentColor" strokeWidth="1" fill="none"/>
  </svg>
);

export default AccountIcon;